import styled from "styled-components";

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-4 mt-6 mb-5 px-8",
})``;

const HalfWidth = styled.div.attrs({
  className: "sm:w-full md:w-6/12 flex flex-col gap-4",
})``;

const CardTitle = styled.div.attrs({
  className: "text-red-500 text-xl font-bold self-start my-12",
})``;

export default {
  FormContainer,
  HalfWidth,
  CardTitle,
};
